// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
// import {User} from '../../core/_models'

type Props = {
  row: Row<any>
}

const CustomRow: FC<Props> = ({row}) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
        >
          <div className='fs-7'>{cell.render('Cell')}</div>
        </td>
      )
    })}
  </tr>
)

export {CustomRow}
